// @flow
import ResourceFill from "components/ResourceFill";
import * as React from "react";
import { useRouteMatch } from "react-router-dom";
import { type Form } from "types/form";
import type { SessionObject } from "types/session-object";
import { ZentakeContext } from "utils/ZentakeContext";

import zentakeAPI, { getForm } from "../api";
import Loading from "../components/Loading";

const sessionId = "preview";

function PreviewForm(): React.Node {
  const match = useRouteMatch();

  const resourceId = match?.params?.resourceId;
  const templateId = match?.params?.templateId;

  const { teamDetails, privateFetchInsuranceCompanies } =
    React.useContext(ZentakeContext);

  const [loading, setLoading] = React.useState(true);
  const [sessions, setSessions] = React.useState<SessionObject>({
    [sessionId]: {
      id: "session",
      isSubmitted: false,
      responses: [],
      templateId: templateId,
    },
  });

  React.useEffect(() => {
    privateFetchInsuranceCompanies();
  }, [privateFetchInsuranceCompanies]);

  React.useEffect(() => {
    const fetchForm = async () => {
      return await getForm(resourceId);
    };

    const fetchTemplate = async () => {
      const response = await zentakeAPI.getTemplate(templateId);
      return response.template;
    };

    const fetchResource = async () => {
      if (resourceId) {
        return await fetchForm();
      }

      return await fetchTemplate();
    };

    const buildFakeAnswers = (form: Form) => {
      const answers = [];

      form.pages.forEach((page) => {
        page.sections.forEach((section) => {
          section.rows.forEach((row) => {
            row.questions.forEach((question) => {
              if (!question.default_value) return;
              answers.push({
                id: "",
                question: question.id,
                answer_raw: question.default_value,
                answer_text: question.default_value,
                answer_files: [],
                response: "",
                question_row: null,
                question_column: null,
              });
            });
          });
        });
      });

      return answers;
    };

    const fetch = async () => {
      if (!teamDetails) return;

      const form = await fetchResource();
      const fakeResponse = {
        form,
        name: "",
        answers: buildFakeAnswers(form),
        created_at: "",
        id: "id",
        is_archived: false,
        is_submitted: false,
        is_scheduled: false,
        internal_user: null,
        team_details: teamDetails,
        uid: "uid",
      };

      setSessions((sessions) => ({
        [sessionId]: {
          ...sessions[sessionId],
          responses: [fakeResponse],
        },
      }));
      setLoading(false);
    };

    fetch();
  }, [resourceId, teamDetails, templateId]);

  if (loading) return <Loading />;

  return (
    <ResourceFill
      mode="preview"
      sessionId={sessionId}
      sessions={sessions}
      setSessions={setSessions}
    />
  );
}

export default PreviewForm;
